import { Layout } from '@glu/core';
import DefaultLabelView from './defaultLabelView';
import template from './listBuilderItemView.hbs';

export default Layout.extend({
  template,
  tagName: 'li',
  className: 'list-builder-item',
  events: {
    'change input': 'toggleSelected'
  },
  modelEvents: {
    'change:listBuilder:isFilteredOut': 'refreshStatesAndClasses'
  },
  regions: {
    itemContent: '.list-builder-item-content'
  },

  initialize(options) {
    this.LabelView = options.labelView || DefaultLabelView;
    this.isLegacy = options.isLegacy;
  },

  onRender() {
    this.itemContent.show(new this.LabelView({
      model: this.model
    }));
  },

  attributes() {
    return {
      'data-item-id': this.model.cid
    };
  },

  templateHelpers() {
    const that = this;
    return {
      isLegacy: this.isLegacy,
      isChecked: this.model.get('listBuilder:isSelected'),
      cid: this.cid,
      getCheckedState() {
        return that.model.get('listBuilder:isSelected') ? 'checked' : '';
      },
      getClassForRootElement() {
        return this.isLegacy ? '' : 'list-builder-flex-wrap';
      }
    };
  },

  toggleSelected() {
    this.model.set('listBuilder:isSelected', this.$('input[type=checkbox]').prop('checked'));
    this.options.layout.toggleControls();
  },

  refreshStatesAndClasses() {
    this.$el.toggleClass('is-filtered-out', this.model.get('listBuilder:isFilteredOut'));
    this.toggleSelected();
  }
});
